import { Component, OnDestroy } from "@angular/core";
import { ModalController, ToastController } from "@ionic/angular";
import { Subject } from "rxjs";
import { OnOff } from "src/graphql/generated/schema";
import { ModalConfirmPinComponent } from "../modal-confirm/modal-confirm-pin.component";
import { ModalGlobalConfirmComponent } from "../global-confirm/global-confirm.component";
import { UserStateService } from "../services/user-state.class";
import { ContactSupportFormComponent } from "../contact-support-form/contact-support-form.component";
import { UpdateModalComponent } from "../components/modals/update-modal/update-modal.component";

@Component({
   template: ''
})
export abstract class CommonPage implements OnDestroy {
   destroy$: Subject<boolean> = new Subject<boolean>();
   isModalPresent:boolean=false;


   constructor(
      public toastController: ToastController,
      public modalCtrl: ModalController,
   ) {
   }

   ngOnDestroy(): void {
      this.destroy$.next(true);
      this.destroy$.unsubscribe();
   }

   defineOnOff(values?: (OnOff | undefined | null)[]): OnOff | undefined {
      if (!values) return undefined;

      let hasString = values.filter(val => typeof val === 'string' && val.length > 0);
      if (hasString.length > 0) {
         if (hasString.filter(val => val?.toUpperCase() === OnOff.On).length > 0) {
            return OnOff.On;
         }
         else {
            return OnOff.Off;
         }
      }

      return undefined;
   }

   defineNumber(value: string | number | undefined | null): number | undefined {
      if (!value) return undefined;
      if (typeof value === 'number') return value;

      if (value.includes('.')) {
        return +(value.substring(0, value.indexOf('.')));
      } else {
        return +value;
      }
   }

   async presentToast(msg: string = 'Settings were reset to default', noTransform: boolean = true, header: string = '') {
      let cssClass = 'custom-toast';
      if (!noTransform) {
         cssClass += '-no-transform';
      }

      if (header && header.trim().length > 0) {
         cssClass += '-left-align';
      }

      const toast = await this.toastController.create({
         header: header,
         message: msg,
         duration: 5000,
         layout: "baseline",
         cssClass: cssClass,
         position: 'bottom',
      });

      await toast.present();
   }

   async openModal(globalPin: boolean = false, pinMode: string = 'confirm'): Promise<boolean> {
      this.isModalPresent = true;
      const modal = await this.modalCtrl.create({
         component: globalPin ? ModalGlobalConfirmComponent : ModalConfirmPinComponent,
         canDismiss: globalPin ? false : true,
         componentProps: {
            pinMode
         }
      });
      modal.present();

      //Closes any modal, but global-pin, after 9min
      if(!globalPin){
         setTimeout(()=>{
         if(modal && modal.canDismiss)
           modal.onWillDismiss();
       },9*60*1000);
      }

      const { data, role } = await modal.onWillDismiss();

      this.isModalPresent = false;

      if (role === 'confirm') {
         return true;
      }
      return false;
   }

   async openUpdateAppBlockerModal(): Promise<boolean> {
      this.isModalPresent = true;
      const modal = await this.modalCtrl.create({
        component: UpdateModalComponent,
        canDismiss: false,
        showBackdrop: true,
        id: 'update-blocker-modal',
      });
      modal.present();
      const { data, role } = await modal.onWillDismiss();

      this.isModalPresent = false;

      if (role === 'confirm') {
         return true;
      }
      return false;
   }

   isModalActive(): Promise<boolean> {
      try{
         return this.modalCtrl.getTop().then((popover:any) => {
            return popover ? true : false;
         });
      }catch(error) {
         return Promise.resolve(this.isModalPresent);
       }
   }
}
